import {
    Alert,
    AlertIcon,
    Button,
    Container,
    DarkMode,
    Flex,
    Heading,
    Text
} from '@chakra-ui/react';
import { useStreamPresenceData } from '@components/Event/provider/StreamPresenceDataProvider';
import { intl_html_values } from '@lib/localization/intl';
import React, { FunctionComponent, useState } from 'react';
import { FormattedMessage } from 'react-intl';

const PresenceControl: FunctionComponent<{ onClickConfirm?: () => void }> = ({
    onClickConfirm
}) => {
    const {
        activeClickSchedule,
        activeClickIsConfirmed,
        confirmStreamPresence
    } = useStreamPresenceData();
    const [sending, setSending] = useState<boolean>(false);
    const [error, setError] = useState<string>('');

    if (!activeClickSchedule || activeClickIsConfirmed) {
        if (sending) {
            setSending(false);
        }
        return null;
    }

    function onConfirm() {
        if (onClickConfirm) {
            onClickConfirm();
        }
        if (confirmStreamPresence && activeClickSchedule) {
            setSending(true);
            confirmStreamPresence(activeClickSchedule)
                .then(() => setSending(false))
                .catch((err) => {
                    setError(err.message);
                    setSending(false);
                });
        }
    }

    return (
        <Flex pos="relative" zIndex="999" w="full" height="full" flexDir="column" justify="center">
            <DarkMode>
                <Container
                    shadow="lg"
                    borderRadius="lg"
                    textAlign="center"
                    color="white"
                    bg="brand.900"
                    p="4"
                    pointerEvents="auto">
                    <Heading as="h2" fontSize="xl">
                        <FormattedMessage
                            id="player.notification.confirm_attendance.header"
                            defaultMessage="Anwesenheit bestätigen"
                            values={{
                                ...intl_html_values
                            }}
                        />
                    </Heading>
                    <Text mt="2" mb="6">
                        <FormattedMessage
                            id="player.notification.confirm_attendance.body"
                            defaultMessage="Dies ist eine akkreditierte Fortbildung. Bitte bestätigen Sie Ihre Anwesenheit."
                            values={{
                                ...intl_html_values
                            }}
                        />
                    </Text>
                    {error ? (
                        <Alert status="error">
                            <AlertIcon />
                            <FormattedMessage
                                id="player.notification.confirm_attendance.error"
                                defaultMessage="Leider ist ein Fehler aufgetreten, bitte versuchen Sie es nochmal bzw. laden Sie die Seite neu.{br}Fehler: {error}"
                                values={{
                                    ...intl_html_values,
                                    error
                                }}
                            />
                        </Alert>
                    ) : null}
                    <Button
                        isDisabled={!confirmStreamPresence || sending}
                        isLoading={!confirmStreamPresence || sending}
                        onClick={onConfirm}
                        variant="outline">
                        <FormattedMessage
                            id="player.notification.confirm_attendance.cta"
                            defaultMessage="Ich bin anwesend."
                            values={{
                                ...intl_html_values
                            }}
                        />
                    </Button>
                </Container>
            </DarkMode>
        </Flex>
    );
};

export default PresenceControl;
